import { Copia, Organ, Plantilla } from './entities'

export interface Filtre {
  titol: string
  nomOrgan: string
  nomPlantilla: string
  dataDesde: string
  csv: string
  id: string
  dataFins: string
  estatElaboracio?: string
  suport: string
  origenDocument: string
  csvRequerit: string
  signaturaOrigen: string
  usuariNom: string
  identificador: string
}

export interface Column {
  id: keyof Organ | keyof Plantilla | keyof Copia
  label: string
  maxWidth?: number
}

export enum TipusLlistat {
  copies = 0,
  organs = 1,
  plantilles = 2
}

export enum TipusPlantilla {
  copia = 0,
  plantilla = 1
}
export interface NovaCopiaType extends Copia, Plantilla {
  usuari: string | null
  valor_manual_csv: string | null
  identificador_document: string | null
  autor_document: string | null
  data_fi_vigencia: string | null
  data_document_original: string | null
  idioma: string | null
  segell_visible: boolean
  num_registre_sortida: string | null
  num_registre_entrada: string | null
  data_registre_sortida: string | null
  data_registre_entrada: string | null
}
